import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const BudgetUpdateModalUI = ({context, messageList, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // budget name
    budgetName, onBudgetNameChange, budgetNameError, setBudgetNameError,
  }) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_update_budget'
    buttonMessageKey='c_update'
    cancelMessageKey='c_cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='budgetName' required={true} maxLength={100}
      messageList={messageList} labelKey='c_budget_name'
      value={budgetName} onChange={onBudgetNameChange}
      error={budgetNameError} setError={setBudgetNameError}
      autoFocus={true}
    />
  </ModalFormUI>

export default BudgetUpdateModalUI
